export default __webpack_public_path__ + "static/media/camera.acce9913.svg";